import PropTypes from 'prop-types';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Row
} from 'reactstrap';
import {
    InfoCard,
    Text
} from 'mol-ui';
import {
    useDispatch,
    useSelector
} from 'hooks';

const HealthIndex = ({
    tabController
}) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        licensesHealthIndex,
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsLicensesHealthIndex(filters));
    };

    const {
        days_difference,
        health_index,
        total_license_days,
        total_license_requested_days
    } = licensesHealthIndex;

    return (
        <StatisticsLayout
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'license_reason', 'position', 'workplace'] }
            loading={ loading }
            tabController={ tabController }
            title={ t('Licencias') }
            onFiltersChange={ onFiltersChange }
        >
            <Row>
                <Text italic margin="10px 0px 0px 0px">
                    { t('El índice de control de salud es calculado mediante la fórmula (Solicitados - Otorgados) / Solicitados') }
                </Text>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Índice de control de salud') }
                        danger={ health_index < 0 }
                        icon="settings"
                        title={ (health_index ?? 0).toString() }
                    />
                </Col>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Diferencia') }
                        danger={ days_difference > 0 }
                        icon={ days_difference > 0 ? 'add_circle' : days_difference < 0 ? 'remove_circle_outline' : 'radio_button_checked' }
                        title={ Math.abs(days_difference) }
                    />
                </Col>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Días otorgados') }
                        icon="assignment_turned_in"
                        title={ (total_license_days ?? 0).toString() }
                    />
                </Col>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Días solicitados') }
                        icon="help"
                        title={ (total_license_requested_days ?? 0).toString() }
                    />
                </Col>
            </Row>
        </StatisticsLayout>
    );
};

HealthIndex.propTypes = {
    tabController: PropTypes.object
};

export default HealthIndex;
